export const amountOf = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const isPositiveAmount = (value) => amountOf(value) > 0;

export const isNonZeroAmount = (value) => amountOf(value) !== 0;

export const formatBillAmount = (value) => amountOf(value).toFixed(2);

export const gstLabel = (percent) =>
  isPositiveAmount(percent) ? `GST (${amountOf(percent)}%)` : "GST";
